import { Content as RadixContent, TabsContentProps } from '@radix-ui/react-tabs'

export type ContentProps = TabsContentProps

export const Content = RadixContent

export default Content
